import HomePageContainer from "../../components/HomepageContainer";

const HomePage = () => {
  return (
    <>
      <HomePageContainer />
    </>
  );
};

export default HomePage;
